module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/stavyToku-b6a49357f37224e895dec6357776b767.svg";